import { Box } from "@mui/material";
import { DropTargetMonitor, useDrop } from "react-dnd";
import { useDragRef } from "./Draggable";

export interface DroppableProps<T = any> {
  accept?: string[] | string;
  onDrop?: (item: T, monitor: DropTargetMonitor) => void;
  onHover?: (item: T, monitor: DropTargetMonitor) => void;
  onClick?: () => void;
  className?: string;
}

const Droppable = (props: React.PropsWithChildren<DroppableProps>) => {
  const {
    accept = ["*"],
    onDrop = () => {},
    onHover = () => {},
    className = "",
    onClick = () => {},
    children,
  } = props;

  const [, dropRef] = useDrop(
    () => ({
      accept,
      drop: onDrop,
      hover: onHover,
    }),
    [onDrop, onHover]
  );

  const handleDragRef = useDragRef(dropRef);

  return (
    <Box className={className} ref={handleDragRef} onClick={onClick}>
      {children}
    </Box>
  );
};

export default Droppable;
